<template>
  <v-flex>
    <!-- Formulario para editar los ordenes del grupo -->
    <v-dialog v-if="this.ordenGrupo" v-model="dialogFormularioOrdenGrupo" :max-width="900" persistent>
      <orden-grupo-formulario @cerrarFormularioOrdenGrupo="dialogFormularioOrdenGrupo = false" />
    </v-dialog>

    <!-- Formulario para crear o editar una grupo -->
    <v-dialog v-if="this.modelGrupo" v-model="dialogFormularioGrupo" :max-width="900" persistent>
      <grupo-formulario @cerrarFormularioGrupo="dialogFormularioGrupo = false" :modelGrupo="this.modelGrupo"
        :accion="this.accionGrupo" />
    </v-dialog>

    <!-- Formulario para crear o editar un origen -->
    <v-dialog v-if="this.modelOrigen" v-model="dialogFormularioOrigen" :max-width="1400" persistent>
      <origen-formulario @cerrarFormularioOrigen="dialogFormularioOrigen = false" :modelOrigen="this.modelOrigen"
        :accion="this.accionOrigen" />
    </v-dialog>

    <!-- Confirmación de eliminación de grupo -->
    <v-dialog v-model="showConfirmacionEliminacionGrupo" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacionGrupo = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar este grupo?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarGrupo()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionGrupo = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirmación de eliminación de origen -->
    <v-dialog v-model="showConfirmacionEliminacionOrigen" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'"
            @click="showConfirmacionEliminacionOrigen = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar el origen?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarOrigen()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionOrigen = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Agencias por Grupo</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearGrupo">
          <span v-bind:style="{ color: 'white' }">
            Nuevo Grupo
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaNombre" autocomplete="off"
              label="Búsqueda" placeholder="Busqueda por nombre" @keyup="changeBusqueda" dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">

          </v-col>
          <v-col cols="4" align="start">

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>

        <v-card v-for="grupo in grupos" :key="grupo.id" class="mb-2" color="rgb(250, 250, 250)">
          <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
            <v-chip label class="mr-1" color="rgb(60, 60, 60)">
              <span v-bind:style="{ color: 'white' }">
                {{ grupo && grupo.origenes ? grupo.origenes.length : '0' }} Agencias
              </span>
            </v-chip>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-toolbar-title :dark="!dark">{{ grupo.nombre }}</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-chip label class="mr-2" link :color="'green lighten-1'" @click="_ordenarProveedores(grupo)">
              <span v-bind:style="{ color: 'white' }">
                Orden de Proveedores
              </span>
            </v-chip>
            <v-chip label class="mr-2" link :color="colorAccent1" @click="_crearOrigen(grupo)">
              <span v-bind:style="{ color: 'white' }">
                Nueva Agencia
              </span>
            </v-chip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip label class="mr-1 px-1" link :color="colorAccent3" @click="_editarGrupo(grupo)" v-on="on">
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-chip>
              </template>
              <span>Editar Grupo</span>
            </v-tooltip>
            <v-tooltip v-if="grupo.origenes.length == 0" bottom>
              <template v-slot:activator="{ on }">
                <v-chip label class="mr-1 px-1" link color="red lighten-2" @click="_deleteGrupo(grupo)" v-on="on">
                  <v-icon color="white">mdi-delete</v-icon>
                </v-chip>
              </template>
              <span>Eliminar Grupo</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-card class="mb-1 elevation-0" v-for="origen in grupo.origenes" :key="origen.id"
              color="rgb(230, 230, 230)">
              <v-card-text>
                <v-row>
                  <span class="ml-1 mt-1 mb-1">
                    {{ origen.nombre }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-chip
                    v-if="mostrarOrdenamientos && (grupo.origenes.length > 0 && origen.id == grupo.origenes[0].id)"
                    label class="mr-1 px-1" color="transparent">
                    <v-icon color="transparent">mdi-arrow-up-bold</v-icon>
                  </v-chip>
                  <v-chip v-if="mostrarOrdenamientos && (origen.id != grupo.origenes[0].id)" label class="mr-1 px-1"
                    link color="green lighten-1" @click="">
                    <v-icon color="white">mdi-arrow-up-bold</v-icon>
                  </v-chip>
                  <v-chip
                    v-if="mostrarOrdenamientos && (grupo.origenes.length > 0 && origen.id == grupo.origenes[grupo.origenes.length - 1].id)"
                    label class="mr-4 px-1" color="transparent">
                    <v-icon color="transparent">mdi-arrow-down-bold</v-icon>
                  </v-chip>
                  <v-chip v-if="mostrarOrdenamientos && origen.id != grupo.origenes[grupo.origenes.length - 1].id" label
                    class="mr-4 px-1" link color="green lighten-1" @click="">
                    <v-icon color="white">mdi-arrow-down-bold</v-icon>
                  </v-chip>
                  <v-chip label small class="mr-1 mt-1 mb-1" link :color="colorAccent3" text-color="white"
                    @click="_editarOrigen(origen)">
                    Editar
                  </v-chip>
                  <v-chip label small class="mr-1 mt-1 mb-1" link color="red lighten-2" @click="_deleteOrigen(origen)"
                    text-color="white">
                    Eliminar
                  </v-chip>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import GrupoFormulario from "../components/formularios/GrupoFormulario";
import OrigenFormulario from "../components/formularios/OrigenFormulario";
import OrdenGrupoFormulario from "../components/formularios/OrdenGrupoFormulario";

export default {
  components: {
    GrupoFormulario, OrigenFormulario, OrdenGrupoFormulario
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaTelefono: "",
    busquedaEmail: "",
    accionGrupo: "",
    accionOrigen: "",

    dialogFormularioGrupo: false,
    modelGrupo: null,
    showConfirmacionEliminacionGrupo: false,

    dialogFormularioOrigen: false,
    modelOrigen: null,
    showConfirmacionEliminacionOrigen: false,
    mostrarOrdenamientos: false,

    dialogFormularioOrdenGrupo: false,

  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorBarraFormularioSecundario",
      "colorFondo300",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("grupos", ["grupos", "grupoSelec", "ordenGrupo"]),
    ...mapState("origenes", ["origenes", "origenSelec"]),

  },

  watch: {},

  mounted() {
    this._getGrupos(true);
  },

  methods: {
    ...mapActions("grupos", ["getGrupos", "eliminarGrupo", "updateGrupo", "getOrdenGrupo"]),
    ...mapMutations("grupos", ["setGrupoSelec"]),
    ...mapActions("origenes", ["getOrigenes", "eliminarOrigen", "updateOrigen"]),
    ...mapMutations("origenes", ["setOrigenSelec"]),

    changeBusqueda(event) { },

    _inicializarModelGrupo() {
      this.modelGrupo = {
        id: null,
        nombre: null,
        descripcion: null,
      };
    },

    _inicializarModelOrigen(grupo_id) {
      this.modelOrigen = {
        id: null,
        grupo_id: grupo_id,
        nombre: null,
        descripcion: null,
        telefono: null,
        email: null,
        responsable: null,
      };
    },

    _imprimir() { },

    async _ordenarProveedores(grupo) {
      await this.getOrdenGrupo([this.access_token, grupo.id]);
      this.dialogFormularioOrdenGrupo = true;
    },

    async _getGrupos(showload) {
      await this.getGrupos([this.access_token, showload]);
      console.log('grupos:', this.grupos);
    },

    _deleteGrupo(item) {
      this.setGrupoSelec(item);
      this.showConfirmacionEliminacionGrupo = true;
    },

    _deleteOrigen(item) {
      this.setOrigenSelec(item);
      this.showConfirmacionEliminacionOrigen = true;
    },

    _crearGrupo() {
      this._inicializarModelGrupo();
      this.accionGrupo = 'crear';
      this.dialogFormularioGrupo = true;
    },

    _crearOrigen(grupo) {
      this._inicializarModelOrigen(grupo.id);
      this.accionOrigen = 'crear';
      this.dialogFormularioOrigen = true;
    },

    _editarGrupo(item) {
      this.setGrupoSelec(item);
      let temp = JSON.parse(JSON.stringify(this.grupoSelec));
      this.modelGrupo = temp;
      this.accionGrupo = 'editar';
      this.dialogFormularioGrupo = true;
    },

    _editarOrigen(item) {
      this.setOrigenSelec(item);
      let temp = JSON.parse(JSON.stringify(this.origenSelec));
      this.modelOrigen = temp;
      this.accionOrigen = 'editar';
      this.dialogFormularioOrigen = true;
    },

    async _eliminarGrupo() {
      this.showConfirmacionEliminacionGrupo = false;
      if (this.grupoSelec != null) {
        await this.eliminarGrupo([this.access_token, this.grupoSelec.id]);
      }
    },

    async _eliminarOrigen() {
      this.showConfirmacionEliminacionOrigen = false;
      if (this.origenSelec != null) {
        await this.eliminarOrigen([this.access_token, this.origenSelec.id]);
      }
    },
  },
};
</script>
